import React from 'react';
import { HomeIcon, FileTextIcon, PhoneIcon, MailIcon, CreditCardIcon } from 'lucide-react';
export function ContactSection() {
  return <section id="kontakt" className="w-full bg-white py-16 border-t border-gray-200" data-id="element-107">
      <div className="max-w-6xl mx-auto px-6" data-id="element-108">
        <div className="grid grid-cols-1 md:grid-cols-[220px_1fr] gap-16" data-id="element-109">
          {/* Left Column - Heading */}
          <div data-id="element-110">
            <h2 className="text-2xl font-normal text-[#707070] tracking-wide" data-id="element-111">
              KONTAKT
            </h2>
          </div>

          {/* Right Column - Contact Details + Image */}
          <div className="grid grid-cols-1 md:grid-cols-[auto_1fr] gap-10" data-id="element-112">
            {/* Contact Details */}
            <div className="space-y-4 min-w-[220px]" data-id="element-113">
              {/* Address */}
              <div className="flex items-start gap-3" data-id="element-114">
                <HomeIcon className="w-4 h-4 text-[#999] mt-1 flex-shrink-0" data-id="element-115" />
                <div className="text-[#707070] text-sm" data-id="element-116">
                  <p data-id="element-117">Dolnoměcholupská 1418/12,</p>
                  <p data-id="element-118">102 00 Praha 10 Hostivař</p>
                </div>
              </div>

              {/* IČ/DIČ */}
              <div className="flex items-start gap-3" data-id="element-119">
                <FileTextIcon className="w-4 h-4 text-[#999] mt-1 flex-shrink-0" data-id="element-120" />
                <div className="text-[#707070] text-sm" data-id="element-121">
                  <p data-id="element-122">IČ: 281 34 800, DIČ: CZ 281 34 800</p>
                </div>
              </div>

              {/* Phone */}
              <div className="flex items-start gap-3" data-id="element-123">
                <PhoneIcon className="w-4 h-4 text-[#999] mt-1 flex-shrink-0" data-id="element-124" />
                <div className="text-[#707070] text-sm" data-id="element-125">
                  <a href="tel:+420737233327" className="hover:text-[#404040] transition-colors" data-id="element-126">
                    +420 737 233 327
                  </a>
                </div>
              </div>

              {/* Email */}
              <div className="flex items-start gap-3" data-id="element-127">
                <MailIcon className="w-4 h-4 text-[#999] mt-1 flex-shrink-0" data-id="element-128" />
                <div className="text-[#707070] text-sm" data-id="element-129">
                  <a href="mailto:info@langard.cz" className="hover:text-[#404040] transition-colors" data-id="element-130">
                    info@langard.cz
                  </a>
                </div>
              </div>

              {/* Bank Details */}
              <div className="flex items-start gap-3" data-id="element-131">
                <CreditCardIcon className="w-4 h-4 text-[#999] mt-1 flex-shrink-0" data-id="element-132" />
                <div className="text-[#707070] text-sm" data-id="element-133">
                  <p data-id="element-134">Č. účtu: 6163218001/5500</p>
                  <p data-id="element-135">Raiffeisen Bank</p>
                  <p data-id="element-136">IBAN:</p>
                  <p data-id="element-137">CZ7755000000006163218001</p>
                </div>
              </div>
            </div>

            {/* Image - larger, clickable to Google Maps */}
            <div className="flex flex-col" data-id="element-138">
              <a href="https://www.google.com/maps/place/Dolnom%C4%9Bcholupsk%C3%A1+1418%2F12,+102+00+Praha+15-Hostiva%C5%99,+Czechia/@50.056531,14.548637,443m/data=!3m1!1e3!4m6!3m5!1s0x470b9287b3f0a417:0x3ba10472aa2316b3!8m2!3d50.0565722!4d14.5486212!16s%2Fg%2F11c5dfqfyx?hl=en&entry=ttu&g_ep=EgoyMDI2MDMwMS4xIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer" className="w-full overflow-hidden group cursor-pointer block" data-id="element-139">
                <img src="https://cdn.magicpatterns.com/uploads/uAF5h8CweRbTUBgy8LvUJy/Image_5.png" alt="Mapa - Praha 10 Hostivař, Dolnoměcholupská" className="w-full h-auto grayscale group-hover:grayscale-0 transition-all duration-500" data-id="element-140" />
              </a>
              <p className="text-xs text-[#999] mt-2" data-id="element-141">
                Klikněte na obrázek pro lepší představu, jak u nás{' '}
                <span className="underline" data-id="element-142">bez problémů</span> zaparkujete
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}